<template>
	<div class="c-map" style="z-index: 0;"></div>
</template>

<script>
	import CoordTrans from '@/assets/script/coord_trans.js'

	export default {
		name: 'cMap',

		methods: {
			init(config, callback) {
				setTimeout(() => {
					try {
						if (!T.gcjLngLat) {
							T.gcjLngLat = function(_lng, _lat) {
								let {lng, lat} = CoordTrans.gcj2Cgcs(_lng, _lat);
								return new T.LngLat(lng, lat);
							}
						}

						if (typeof config == 'function') {
							callback = config;
							config = undefined;
						}

						config = Object.assign({
							resetViewport: true,
							center: [104.50195, 34.10238],
							zoom: 5
						}, config);

						this._reset = () => {
							this._map.centerAndZoom(new T.gcjLngLat(config.center[0], config.center[1]), config.zoom);
						}

						if (!this._map) {
							this._map = new T.Map(this.$el, {
								center: new T.gcjLngLat(config.center[0], config.center[1]),
								zoom: config.zoom,
								minZoom: 5
							});
							let control = new T.Control.Zoom();
							control.setPosition(T_ANCHOR_BOTTOM_RIGHT);
							this._map.addControl(control);
							this._map.setMaxBounds(new T.LngLatBounds(new T.LngLat(72.08203, 15.28419), new T.LngLat(137.17578, 53.95609)));

							this._overlay = T.Overlay.extend({
								initialize(lnglat, dom, opt) {
									opt = Object.assign({
										offsetX: '0px',
										offsetY: '0px'
									}, opt)
									this._lnglat = lnglat;
									this._dom = $('<div class="flex-center-end"></div>').css({
										position: 'absolute',
										width: 0,
										height: 0
									}).append($(dom).css({
										'z-index': opt.zIndex,
										position: 'absolute',
										left: 0,
										bottom: 0,
										transform: `translate(calc(-50% + ${opt.offsetX}),calc(0px + ${opt.offsetY}))`
									}))[0];
								},
								onAdd(map) {
									this._map = map;
									map.getPanes().overlayPane.appendChild(this._dom);
									this.update(this._lnglat);
								},
								onRemove() {
									this._dom.parentNode.removeChild(this._dom);
									this._map = null;
									this._dom = null;
								},
								setLnglat(lnglat) {
									this._lnglat = lnglat;
									this.update();
								},
								getLnglat() {
									return this._lnglat;
								},
								setPos(pos) {
									this._lnglat = this._map.layerPointToLngLat(pos);
									this.update();
								},
								update() {
									var pos = this._map.lngLatToLayerPoint(this._lnglat);
									this._dom.style.top = pos.y + 'px';
									this._dom.style.left = pos.x + 'px';
								},
								getElement() {
									return this._dom;
								}
							});
						} else {
							if (config.resetViewport) {
								this._reset();
							}
						}
						callback && callback(this._map);
					} catch(e) {
						console.log(e);
						this.init(config, callback);
					}
				}, 100);
			},

			reset() {
				this._reset();
			},

			overlay(lng, lat, dom, opt = {}) {
				let overlay = new this._overlay(opt.type == 'cgcs' ? new T.LngLat(lng, lat) : new T.gcjLngLat(lng, lat), dom, opt, {});
				this._map.addOverLay(overlay);
				return overlay;
			}
		}
	}
</script>

<style lang="stylus">
	.c-map {
		img {
			max-width: none;
			max-height: none;
		}
	}
</style>